import styled from 'styled-components';

import type {
  MenuItemProps,
  MenuItemComponent,
} from '../types';

export const MenuItem: MenuItemComponent = styled.div<MenuItemProps>(({
  $isHighlighted,
}) => ({
  display: 'block',
  boxSizing: 'border-box',
  padding: '10px',
  color: '#666',
  backgroundColor: $isHighlighted ? '#f9f9f9' : '#fff',
  cursor: 'pointer',
}));
